import { render, staticRenderFns } from "./Index2.vue?vue&type=template&id=ec233612&scoped=true"
import script from "./Index2.vue?vue&type=script&lang=js"
export * from "./Index2.vue?vue&type=script&lang=js"
import style0 from "./Index2.vue?vue&type=style&index=0&id=ec233612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec233612",
  null
  
)

export default component.exports